import React, { useState } from 'react'
import { ControleLateral } from '../../styled'
import { Box } from '../../../../../../../../../../../../../../Components/CustomUi/box'
import { Switcher } from '../../../../../../../../../../../../../../Components/CustomUi/Switcher'
import { Select } from '../../../../../../../../../../../../../../Components/CustomUi/Select'
import { GeoPointFeature } from '../..'
import { LabAnaliseItens } from '../../../../../../../../../../../../../../services/LabAnalise'
import { LineDivider } from '../../../../../../../../../../../../../../Components/CustomUi/LineDivider'
import { ContainerPontosAnalise } from '../../../../styled'
import ButtonCustom from '../../../../../../../../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCube, faPlus, faSquare } from '@fortawesome/free-solid-svg-icons'
import { PontosAdicionados } from '../pontosAdicionados'
import { Render } from '../../../../../../../../../../../../../../Components/CustomUi/render'
import { Empty } from 'antd'
import { calcularPorcentagem } from '../../../../../../../../../meta'

interface PropsControle {
  inserirPontos: boolean
  setInserirPontos: React.Dispatch<React.SetStateAction<boolean>>
  moverPontos: boolean
  setMoverPontos: React.Dispatch<React.SetStateAction<boolean>>
  pontos?: GeoPointFeature[] | any
  pontos_totais: number
  talhao_area: string
  tipo_analise_selecionada: string
  setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
  setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  cor_selecionada: string
  setCor_selecionada: React.Dispatch<React.SetStateAction<string>>
  selecionarTodos: boolean
  grupoAnalises: LabAnaliseItens[]
  pontos_selecionados_adicionados: any[]
  fake_loading: boolean
  adicionarPontosSelecionados: Function
  selecionarTodosPontos: Function
  deletarPontosSelecionados: Function
  grupoAnalisesTratado: any[]
  isFullscreen?: boolean
}

export const ControleLateralModal: React.FC<PropsControle> = ({
  inserirPontos,
  setInserirPontos,
  moverPontos,
  setMoverPontos,
  tipo_analise_selecionada,
  setTipo_analise_selecionada,
  setTipo_analise_selecionada_id,
  cor_selecionada,
  setCor_selecionada,
  selecionarTodos,
  grupoAnalises,
  pontos_totais,
  talhao_area,
  pontos,
  pontos_selecionados_adicionados,
  fake_loading,
  adicionarPontosSelecionados,
  selecionarTodosPontos,
  deletarPontosSelecionados,
  grupoAnalisesTratado,
  isFullscreen = false,
}) => {
  const [openSelecionar, setOpenSelecionar] = useState<boolean>(false)

  function selectCor(cod) {
    setTipo_analise_selecionada_id(cod)
    const filter = grupoAnalisesTratado?.filter((item) => item?.cod_analise === cod)
    setCor_selecionada(filter[0]?.cor)
  }

  const Wrapper = isFullscreen ? React.Fragment : ControleLateral

  return (
    <Wrapper>
      <Box>
        <label
          style={{ fontSize: '12px', fontWeight: 700, color: '#7b7b7b', margin: 0, padding: 0 }}
        >
          Pontos ({pontos?.length})
        </label>

        <Select
          label='Profundidade | Análises'
          placeholder='Selecione a análise'
          icon={faSquare}
          value={tipo_analise_selecionada}
          onChange={setTipo_analise_selecionada}
          onChangeID={(e) => selectCor(e)}
          onChangeExtra={setCor_selecionada}
          open={openSelecionar}
          trigger={setOpenSelecionar}
          items={grupoAnalisesTratado}
          descricaoItem={'analise_profundidade_nome'}
          idItem={'cod_analise'}
          cor={cor_selecionada}
          extraItem={'cor'}
        />

        <Switcher
          label='Selecionar todos os pontos'
          isChecked={selecionarTodos}
          trigger={(checked) => selecionarTodosPontos(checked)}
          disabled={inserirPontos}
        />

        <LineDivider />

        <ContainerPontosAnalise>
          <h3 className='points-title'>Pontos selecionados</h3>
          <Render condition={pontos?.length > 0}>
            <div className='points-grid'>
              {pontos?.map((point, index) => (
                <div
                  key={index}
                  className='point-card'
                  style={
                    {
                      '--cor-do-item': point?.COR,
                    } as React.CSSProperties
                  }
                >
                  {point?.NOME.toString().padStart(2, '0')}{' '}
                  {/* Garante 2 dígitos (07, 09...) */}
                </div>
              ))}
            </div>
          </Render>

          <Render condition={pontos?.length <= 0}>
            <Empty
              style={{
                display: 'flex',
                fontSize: '12px',
                height: '30px',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 3,
                padding: 0,
                margin: 0,
              }}
              imageStyle={{ width: '30px', height: '30px', padding: 0, margin: 0 }}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<p style={{ margin: 0, padding: 0 }}> Nenhum ponto selecionado!</p>}
            />
          </Render>
          <div className='infos__pontos__selecionados'>
            <div>
              <label>Pontos</label>
              <strong>{`${pontos?.length} de ${pontos_totais} ${calcularPorcentagem(
                pontos?.length,
                pontos_totais
              )}`}</strong>
            </div>
            <div>
              <label>Grid amostral</label>
              <strong>
                {pontos.length > 0 ? (Number(talhao_area) / pontos.length).toFixed(2) : 0}{' '}
              </strong>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonCustom
              type='secondary'
              onClick={adicionarPontosSelecionados}
              icon={<FontAwesomeIcon icon={faPlus} />}
            >
              Adicionar análise
            </ButtonCustom>
          </div>
        </ContainerPontosAnalise>
      </Box>
      <Render condition={pontos_selecionados_adicionados?.length > 0}>
        <Box style={{ maxHeight: '230px', overflowY: 'auto' }} gap={5}>
          <h3
            style={{ color: '#757575', fontSize: '12px', fontWeight: 700, margin: 0, padding: 0 }}
          >
            Pontos adicionados
          </h3>
          <PontosAdicionados
            pontos_selecionados_adicionados={pontos_selecionados_adicionados}
            deletarPontosSelecionados={deletarPontosSelecionados}
            fake_loading={fake_loading}
          />
        </Box>
      </Render>
    </Wrapper>
  )
}
